import React, { useState } from "react"
import { library } from "@fortawesome/fontawesome-svg-core"
import { fas } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import NewOpportunityModal from "./NewOpportunityModal"
library.add(fas)

// Renders the "+ Opportunité" toolbar button and its quick-create modal.
const NewOpportunityButton = (props) => {
  const [open, setOpen] = useState(false)
  return (
    <>
      <button
        type      = "button"
        onClick   = {() => setOpen(true)}
        className = "inline-flex items-center gap-2 bg-blue-600 text-white rounded-lg px-3.5 py-2 text-[13px] font-medium hover:bg-blue-700 transition"
      >
        <FontAwesomeIcon icon="plus" className="text-[12px]" />
        {I18n.t("crm.opportunities.new_button")}
      </button>
      <NewOpportunityModal isOpen={open} onClose={() => setOpen(false)} {...props} />
    </>
  )
}

export default NewOpportunityButton
